module.exports = __webpack_public_path__ + "static/media/water-meter.045bc2f3.png";